import { ReactElement, ReactNode } from 'react';
import { LockedFieldset } from './styles';

interface RestrictableSectionProps {
  restricted: boolean;
  children: ReactNode;
}

// Mantém os campos visíveis mas sem edição. O fieldset desabilita os inputs nativos e o
// pointer-events bloqueia os controles que não são nativos (toggles, selects customizados).
// Sem restrição, devolve os filhos sem wrapper para não alterar o layout de quem já usa o formulário.
// Use quando os campos travados formam um bloco contíguo; campos editáveis intercalados com os
// travados no mesmo grid (ex.: FormEditUnit) usam `disabled` campo a campo.
export function RestrictableSection({ restricted, children }: Readonly<RestrictableSectionProps>): ReactElement {
  if (!restricted) return <>{children}</>;
  return (
    <LockedFieldset disabled aria-disabled>
      {children}
    </LockedFieldset>
  );
}
